"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _DropdownLinkModule = _interopRequireDefault(require("./DropdownLink.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var propTypes = {
  link: _propTypes.default.string,
  linkTitle: _propTypes.default.string.isRequired,
  text: _propTypes.default.string,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    link: _propTypes.default.string,
    icon: _propTypes.default.object,
    buttonColor: _propTypes.default.oneOf(['red', 'orange', 'blue', 'dark-blue', 'green', 'dark-green', 'custom-green', 'grey', 'dark'])
  })),
  displayAsLink: _propTypes.default.bool
};
var defaultProps = {
  link: '#',
  text: '',
  buttons: undefined,
  displayAsLink: true
};

var DropdownLink = function DropdownLink(_ref) {
  var link = _ref.link,
      linkTitle = _ref.linkTitle,
      text = _ref.text,
      buttons = _ref.buttons,
      displayAsLink = _ref.displayAsLink;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  return _react.default.createElement("div", {
    className: _DropdownLinkModule.default.container
  }, displayAsLink ? _react.default.createElement(_reactRouterDom.Link, {
    className: "link link-grid",
    onMouseEnter: function onMouseEnter() {
      return setShowDropdown(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowDropdown(false);
    },
    to: link,
    title: linkTitle
  }, text) : _react.default.createElement("span", {
    onMouseEnter: function onMouseEnter() {
      return setShowDropdown(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowDropdown(false);
    }
  }, text), buttons && _react.default.createElement(_Dropdown.default, {
    isVisible: showDropdown,
    buttons: buttons
  }));
};

DropdownLink.propTypes = propTypes;
DropdownLink.defaultProps = defaultProps;
var _default = DropdownLink;
exports.default = _default;